// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"2bec3a08","271":"85e63458","407":"8dd22bf0","638":"cf1608ec"}[chunkId] + ".chunk.js";
};